<template>
  <div class="teacher">
    <van-swipe :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="teacher in teachers" :key="teacher.id">
        <van-image :src="teacher" alt >
           <template v-slot:loading>
                  <van-loading size="20" color="#fff" />
                </template>
        </van-image>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      teachers: this.teacherUrl
    };
  },
  props: {
    teacherUrl: {
      type: Array,
      default: []
    }
  }
};
</script>

<style scoped>
.teacher {
  width: 100%;
}
</style>

